module.exports = __webpack_public_path__ + "static/media/10.d6b9f088.jpg";